export default __webpack_public_path__ + "static/media/Red.1a3e38c8.png";